import { combineReducers } from "redux";
import loading from "./loading";
import tab from "./tab";

const rootReducer = combineReducers({
  loading,
  tab,
});

export default rootReducer;